<template>
    <div>
      <national-patent-application-type-list></national-patent-application-type-list>
    </div>
  </template>
  <script>
  export default {
  }
  </script>
